import React from 'react';
import {
  FormSubsectionType,
  RICMetadata,
} from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import {
  formatCurrency,
  calculateSumValue,
} from '@upstart/harmony/lib/ric-form-utils';
import { SectionItem } from '../Components';
import { renderElement } from './SchemaFormElementRenderer';

export const SchemaSubSection = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  ricMetadata,
}: {
  formElement: FormSubsectionType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RICMetadata;
}) => {
  const { title, subtitle, value, sumValue, subSectionElements } = formElement;

  const strValue = sumValue
    ? formatCurrency(calculateSumValue(responseData, sumValue))
    : value ?? '';

  const renderSectionElements = () =>
    subSectionElements?.map(sectionElement =>
      renderElement({
        formElement: sectionElement,
        responseData,
        fetchResponseWithUpdatedData,
        isSubSectionElement: true,
        ricMetadata,
      }),
    );

  return (
    <>
      <SectionItem title={title} subtitle={subtitle} value={strValue} />
      <div className="form-subsection">
        {subSectionElements && renderSectionElements()}
      </div>
    </>
  );
};

export default SchemaSubSection;
